import React, { useEffect, useContext ,useState } from "react";
import ReactDOM from "react-dom";
import { useParams } from "react-router-dom";

import Details from "components/tak-arz/Details";
import Sarafi from "components/tak-arz/Sarafi";
import About from "components/tak-arz/About";
import Diagram from "components/tak-arz/Diagram";
import DetailsSide from "components/tak-arz/DetailsSide";
// import Twittes from "components/common/twitte/Twittes";
import { sendRequestAPIMain } from "hooks/useAxios";

import first from "../assets/images/first.png";
import second from "../assets/images/second.png";
import third from "../assets/images/third.png";
import four from "../assets/images/profile.png";

import user from "../assets/images/Icon awesome-user-alt.png";
import imageTwitter from "../assets/images/ImageTwitter.png";
import Binance from "../assets/images/binance (2).png";
// import twitteContext from "context/twitteContext";
// import TwitteModal from "components/common/twitte/TwitteModal";
const TakArz = () => {
  const { query } = useParams();
  const [data, setData] = useState([]);

  
  useEffect(() => {
    sendRequestAPIMain("singlecc", { cc_symbol: `${query}` }).then((res) => {
      setData(res.data);
      console.log("res", res.data.cc_meta_data.Farsi_description);
    });
    // setParams(query.id)
  },[])
  
    const details = {
      name: "بایننس کوین",
      icon: Binance,
      nameE: `binance coin(${query})`,
      nameChart: `BINANCE:${query}USDT`,  
      rank: 4,
      url: "https://www.binance.com/",
      search: [{ value: "mintscan" }, { value: "binance" }],
      moment: [23.4, 24, 6, 24.4, 25, 7, 27.8, 26.9, 27.5, 27.85, 28.08],
      daily: {
        dollar: 27461400000,
        toman: 1732841093,
        teter: 28080,
      },
      // about: ` ${data.Farsi_description}`,
      detail: {
        price: 67181,
        totalMarketVolume: 58909600000.0,
        dominanceOfTheMarket: 3.39,
        dailyTradingVolume: 2449570000.0,
        lowest24hour: 350.4,
        highest24hour: 387.29,
        lowest7days: 350.41,
        highest7days: 433.38,
        // rankInTheMarket:4, از بالا گرفته شود
        peak: {
          peakDollarPrice: 687.6,
          changes: { sign: "negative", value: 47.52 },
          dollar: 22525,
          // imToman:peakDollarPrice * dollar,
          time: { gCalendar: "10 may 2021", sCalendar: "20 اردیبهشت 1400" },
        },
        changes: {
          _1hour: { sign: "positive", value: 1.42 },
          _1day: { sign: "negative", value: 4.35 },
          _7days: { sign: "negative", value: 14.93 },
          _14days: { sign: "negative", value: 4.35 },
          _30days: { sign: "negative", value: 14.93 },
          _60days: { sign: "negative", value: 14.93 },
          _6month: { sign: "positive", value: 1.42 },
          _1year: { sign: "positive", value: 1.42 },
          _2year: { sign: "positive", value: 1.42 },
        },
        priceToBitcoin: 0.009718,
        dateOfGenesis: "2017-07-08",
        currencyAvailable: 165.1,
      },
      twittes: [
        {
          isComment: false,
          key: 1,
          parentKey: 1,
          type: 1,
          name: "بورس نگر",
          id: "boursnegar",
          image: first,
          time: "13 دقیقه پیش",
          hashtag: [{ value: "پالایش" }],
          content: {
            type: 1,
            value: {
              text: `خروج سنگین پول امروز از صندوق های درآمد ثابت شاید نوید
            خوبی برای رشد بازارهست ،و اینکه وزیر اقتصاد سه شنبه به
            مجلس میرود ،حالا تصمیم فروش با خودتان`,
              image: null,
            },
          },
          statistics: {
            comment: 3,
            like: 17,
            dislike: 4,
          },
          comments: [],
        },
        {
          isComment: false,
          key: 2,
          parentKey: 2,
          type: 1,
          name: "رامی",
          id: "rami",
          image: second,
          time: "15 ساعت پیش",
          hashtag: [{ value: "خودرو" }],
          content: {
            type: 1,
            value: {
              text: `
              خبر بسیار مهم ایرانخودرو
             ا یران خودرو برنامه واگذاری شرکتهای غیربورسی خود از طریق 
             پذیرش در بازار سرمایه و عرضه اولیه آنها را در دست اقدام دارد 
              عرضه اولیه سمند نزدیکه `,
              image: null,
            },
          },
          statistics: {
            comment: 3,
            like: 17,
            dislike: 4,
          },
          comments: [],
        },
        {
          isComment: false,
          key: 3,
          parentKey: 4,
          type: 1,
          name: "محمد",
          id: "mohammad",
          image: third,
          time: "15 ساعت پیش",
          hashtag: [{ value: "فازر" }, { value: "ارز" }],
          content: {
            type: 2,
            value: {
              text: `حمایت ار اس ای هم شکست`,
              image: imageTwitter,
            },
          },
          statistics: {
            comment: 3,
            like: 17,
            dislike: 4,
          },
          comments: [{ value: 5 }, { value: 6 }, { value: 7 }],
        },
        {
          isComment: false,
          key: 4,
          parentKey: 4,
          type: 2,
          name: "علی",
          id: "ali8554",
          image: user,
          time: "15 ساعت پیش",
          hashtag: [{ value: "خکاوه" }],
          content: {
            type: 1,
            value: {
              text: `فعلا به تکنیکال خوب جواب میده دیروز رفت برای
              استراحت من از صف خرید خارج شدم`,
              image: null,
            },
          },
          statistics: {
            comment: 3,
            like: 17,
            dislike: 4,
          },
          comments: [],
        },
        {
          isComment: true,
          key: 5,
          parentKey: 5,
          type: 1,
          name: "بورس نگر",
          id: "boursnegar",
          image: first,
          time: "15 ساعت پیش",
          hashtag: [{ value: "شلرد" }],
          content: {
            type: 1,
            value: {
              text: `هیچکس نمیخواد بخره و نمیخواد بفروشه`,
              image: null,
            },
          },
          statistics: {
            comment: 3,
            like: 17,
            dislike: 4,
          },
          comments: [{ value: 7 }],
        },
        {
          isComment: true,
          key: 6,
          parentKey: 6,
          type: 1,
          name: "رامی",
          id: "rami",
          image: second,
          time: "15 ساعت پیش",
          hashtag: [],
          content: {
            type: 1,
            value: {
              text: `18  سال استراحت کرده`,
              image: null,
            },
          },
          statistics: {
            comment: 3,
            like: 17,
            dislike: 4,
          },
          comments: [],
        },
        {
          isComment: true,
          key: 7,
          parentKey: 7,
          type: 1,
          name: "همفکری بورس",
          id: "azin_a234",
          image: four,
          time: "15 ساعت پیش",
          hashtag: [],
          content: {
            type: 1,
            value: {
              text: `همیشه صعودی است اما ایا تو این شرایط معمله درست است؟ btc`,
              image: null,
            },
          },
          statistics: {
            comment: 3,
            like: 17,
            dislike: 4,
          },
          comments: [{ value: 6 }],
        },
      ],
    };

  // const { setTwittes } = useContext(twitteContext);
  // useEffect(() => {
  //   setTwittes(details.twittes);
  // }, []);
  return (
    <>
      {data.status == 0 && data.status == undefined ? (
        ""
      ) : (
        <>
          <Details details={details} data={data} />
          <Sarafi details={data} />
          <About details={data} />
          <Diagram details={details} data={data} />

          {/* <div
            className="row container1"
            style={{ borderTop: "1px solid #707070" }}
          >
            <DetailsSide details={details} />
            <Twittes twittes={details.twittes} />
          </div> */}
        </>
      )}

      {/* {ReactDOM.createPortal(
        <TwitteModal />,
        document.getElementById("modals")
      )} */}
    </>
  );
};

export default TakArz;
